import React, { PureComponent } from 'react';

import TwitterIcon from 'react-icons/lib/fa/twitter';
import FacebookIcon from 'react-icons/lib/fa/facebook';

import './Sharer.scss';

class Sharer extends PureComponent {
  render() {
    const { title, url, description, image } = this.props;
    const titleEncoded = encodeURIComponent(title);
    const urlEncoded = encodeURIComponent(url);
    const descriptionEncoded = encodeURIComponent(description);
    const imgSrcEncoded = encodeURIComponent(image);

    const appId = '233637913776972';

    const TwitterHref = `https://twitter.com/intent/tweet?text=${titleEncoded}&url=${urlEncoded}`;
    const FacebookHref = `https://www.facebook.com/dialog/share?app_id=${appId}&display=popup&href=${urlEncoded}&title=${titleEncoded}&description=${descriptionEncoded}&picture=${imgSrcEncoded}`;

    return (
      <div className="vis-sharer">
        <div className="vis-sharer--title">{window.config.labels.sharing_info}</div>
        <div className="vis-sharer--icons">
          <a href={TwitterHref} target="_blank" className="vis-sharer--link">
            <TwitterIcon color="#1da1f2"/><span className="vis-sharer--label">Twitter</span>
          </a>
          <a href={FacebookHref} target="_blank" className="vis-sharer--link">
            <FacebookIcon color="#3b5998"/><span className="vis-sharer--label">Facebook</span>
          </a>
        </div>
      </div>
    );
  }
}

export default Sharer;



// WEBPACK FOOTER //
// ./src/Component/Sharer/index.js